import type { Locale } from '@lemonade-hq/lemonation';
import type { Config as ConfigEnUS } from './us/en';
import type { Config as ConfigFrFr } from './fr/en';
import type { Config as ConfigFrEn } from './fr/fr';
import { config as enUsConfig } from './us/en';
import { config as enFRConfig } from './fr/en';
import { config as frFRConfig } from './fr/fr';

export type Config = ConfigEnUS | ConfigFrFr | ConfigFrEn;

export const homeownersTemplateConfig = {
  'en-US': enUsConfig,
  'en-GB': enUsConfig,
  'en-FR': enFRConfig,
  'en-DE': enUsConfig,
  'en-NL': enUsConfig,
  'nl-NL': enUsConfig,
  'de-DE': enUsConfig,
  'fr-FR': frFRConfig,
} as Record<Locale, Config>;
